import { render, staticRenderFns } from "./zcList.vue?vue&type=template&id=6c64bc93&scoped=true"
import script from "./zcList.vue?vue&type=script&lang=js"
export * from "./zcList.vue?vue&type=script&lang=js"
import style0 from "./zcList.vue?vue&type=style&index=0&id=6c64bc93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c64bc93",
  null
  
)

export default component.exports